import { createSlice } from '@reduxjs/toolkit';
import { IInterceptionsState } from 'interfaces';

import { reducersNames } from '../../../constants/reducers';

import {
  getInterceptionDepartmentsThunk,
  getInterceptionMembersThunk,
  getInterceptionNetworksThunk,
  getInterceptionsListThunk,
  getInterceptionTranscriptsByIdThunk,
} from './actions';

const initialState: IInterceptionsState = {
  interceptions: [],
  members: [],
  networks: [],
  currentTranscripts: [],
  departments: [],
};

const interceptionSlice = createSlice({
  name: reducersNames.INTERCEPTIONS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInterceptionsListThunk.fulfilled, (state, action) => {
        state.interceptions = action.payload;
      })
      .addCase(getInterceptionNetworksThunk.fulfilled, (state, action) => {
        state.networks = action.payload;
      })
      .addCase(getInterceptionMembersThunk.fulfilled, (state, action) => {
        state.members = action.payload;
      })
      .addCase(
        getInterceptionTranscriptsByIdThunk.fulfilled,
        (state, action) => {
          state.currentTranscripts = action.payload;
        }
      )
      .addCase(getInterceptionDepartmentsThunk.fulfilled, (state, action) => {
        state.departments = action.payload;
      });
  },
});

export const { actions: interceptionActions, reducer: interceptionReducer } =
  interceptionSlice;
